<template>
    <div class="livetiming margin--bottom-4 margin--top-4">
      <div v-if="utcHours > 6 && utcHours < 17 && result && Object.keys(drivers).length && result.SESSION.toUpperCase().indexOf('TEST') === -1" class="container-fluid">
        <!-- RACE -->
        <div>
          <h4>{{ result.SESSION }}</h4>
          <p>TIME LEFT: {{ result.TIME }}</p>
          <div class="box-shadow">
            <div class="overflow--auto">
              <table class="timing" cellspacing="0">
                <thead>
                <tr>
                  <th class="tl" colspan="2">Pos</th>
                  <th class="tl">Driver</th>
                  <th class="tl">Gap</th>
                  <th class="tl">Int</th>
                  <th class="tl" v-if="result.TYPE === 'RACE'">Last Lap</th>
                  <th class="tl" v-if="result.TYPE === 'RACE'">S1</th>
                  <th class="tl" v-if="result.TYPE === 'RACE'">S2</th>
                  <th class="tl" v-if="result.TYPE === 'RACE'">S3</th>
                  <th class="tl">Best Lap</th>
                  <th class="tl">LAPS</th>
                  <th class="tl">PITSTOPS</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(rec, i) in result.REC" :key="i" class="timing__tr">
                  <td class="text-condensed">{{ rec.LINE }}</td>
                  <td class="padding-0 va-center" valign="center" width="18">
                    <svg class="timing__icon"
                         :class="{ 'timing__icon--up': drivers[rec.ST].update.LINE < 0, 'timing__icon--down': drivers[rec.ST].update.LINE > 0 }"
                         fill="fill-bg"
                         height="18px"
                         width="18px"
                         viewBox="0 0 24 24"
                         xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                         xml:space="preserve"><g id="arrow" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Icon-24px" transform="translate(8.000000, 5.500000)"><polygon id="Shape" points="7.41 11.09 2.83 6.5 7.41 1.91 6 0.5 0 6.5 6 12.5"></polygon></g></g></svg>
                  </td>
                  <td class="padding-right text-condensed" v-html="fullName(rec.NM)"></td>
                  <td class="text-condensed padding-right">
                    {{ rec.G === 'LAP' ? 'LAP ' + rec.LAPS : rec.G }}
                  </td>
                  <td class="text-condensed padding-right" :class="{ 'text-transparent': rec.I === 'LAP' }">
                    {{ rec.I === rec.LAPS ? ' ' : rec.I }}
                  </td>
                  <td class="text-condensed padding-right" :class="{
                    'text-pink': rec.LLAPST === 'BLUE',
                    'text-green': rec.LLAPST === 'GREEN',
                    'text-transparent': !rec.G
                  }" v-if="result.TYPE === 'RACE'">{{ rec.LLAP }}</td>
                  <td class="text-condensed padding-right" :class="{
                    'text-pink': rec.S1TST === 'BLUE',
                    'text-green': rec.S1TST === 'GREEN',
                    'text-transparent': !rec.S1T
                  }" v-if="result.TYPE === 'RACE'">{{ rec.S1T || '00.000' }}</td>
                  <td class="text-condensed padding-right" :class="{
                    'text-pink': rec.S2TST === 'BLUE',
                    'text-green': rec.S2TST === 'GREEN',
                    'text-transparent': !rec.S2T
                  }" v-if="result.TYPE === 'RACE'">{{ rec.S2T || '00.000' }}</td>
                  <td class="text-condensed padding-right" :class="{
                    'text-pink': rec.S3TST === 'BLUE',
                    'text-green': rec.S3TST === 'GREEN',
                    'text-transparent': !rec.S3T
                  }" v-if="result.TYPE === 'RACE'">{{ rec.S3T || '00.000' }}</td>
                  <td class="text-condensed padding-right">{{ rec.FL }}</td>
                  <td class="text-condensed">{{ rec.LAPS }}</td>
                  <td class="text-condensed" :class="{ 'text-pink': rec.INPIT }">{{ rec.INPIT ? 'IN PIT' : rec.STOPS * 1 }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import AppConst from '../../config/app.const';
import axios from 'axios';

export default {
  name: 'WigeLivetiming',
  props: {
    event: { type: String, default: '22' }
  },
  data () {
    return {
      result: null,
      isLive: false,
      delayLive: 2000,
      fetching: false,
      liveInterval: false,
      debug: true,
      testFile: '',
      utcHours: 0,
      testFiles: [
        'testfiles/live.race.json',
        'testfiles/live.race.lap20.json',
        'testfiles/live.race.lap22.json',
        'textfiles/live.training.json'
      ],
      history: [],
      drivers: {}
    };
  },
  methods: {
    fullName: function (input) {
      const name = input.split(' ');
      let firstName = '';
      let lastName = input;
      if (name.length) {
        firstName = name[name.length - 1];
        // extra for Jan Philipp
        if (input.indexOf('Jan Philipp') > -1 || input.indexOf('Jose Maria') > -1) {
          firstName = name[name.length - 2] + ' ' + name[name.length - 1];
        }
        lastName = input.substr(0, input.length - firstName.length).trim();
      }
      return '<span class="d-none d-md-inline-block">' + firstName + '</span><b> ' + lastName + '</b>';
    },
    time2seconds: function (value) {
      const tmp = value.split(':');
      return (tmp[0] * 60) + parseFloat(tmp[1]);
    },
    compareData: function (newValue, oldValue) {
      const newHasLap = newValue.indexOf('L') > -1;
      const oldHasLap = oldValue.indexOf('L') > -1;
      const newIsTime = newValue.indexOf(':') > -1;
      const oldIsTime = oldValue.indexOf(':') > -1;
      // if new GAP/INT has LAP and old not, it's slower
      if (newHasLap && !oldHasLap) {
        return 1;
      }
      if (!newHasLap && oldHasLap) {
        return -1;
      }
      // if it's a x:xx.xxx value we have to calculate the seconds
      if (newIsTime) {
        newValue = this.time2seconds(newValue);
      }
      if (oldIsTime) {
        oldValue = this.time2seconds(oldValue);
      }
      newValue = parseFloat(newValue);
      oldValue = parseFloat(oldValue);
      return newValue > oldValue ? 1 : newValue < oldValue ? -1 : 0;
    },
    async fetchStream () {
      if (!this.fetching) {
        this.fetching = true;
        if (this.debug && this.testFile) {
          await axios.get(this.testFile)
            .then(response => {
              this.result = 'RESULT' in response ? response.RESULT : 'RESULT' in response.data ? response.data.RESULT : '';
              this.fetching = false;
            })
            .then(() => {
              this.fetching = false;
            });
        } else {
          await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
            path: 'live?event=' + this.event
          })
            .then(response => {
              if ('RESULT' in response) {
                if ('REC' in response.RESULT) {
                  const now = new Date();
                  this.utcHours = now.getUTCHours();
                  try {
                    response.RESULT.REC.forEach((rec) => {
                      if (!(rec.ST in this.drivers)) {
                        const driver = {
                          LINE: rec.LINE,
                          ST: rec.ST,
                          T: rec.T,
                          G: rec.G,
                          I: rec.I,
                          S1T: rec.S1T,
                          S2T: rec.S2T,
                          S3T: rec.S3T,
                          FL: rec.FL,
                          LAPS: rec.LAPS,
                          update: {
                            LINE: 0,
                            T: 0,
                            G: 0,
                            I: 0,
                            FL: 0
                          },
                          last: {}
                        };
                        this.drivers[rec.ST] = driver;
                      }
                      // set update values for important data
                      if (rec.LAPS !== this.drivers[rec.ST].LAPS || rec.LINE !== this.drivers[rec.ST].LINE) {
                        this.drivers[rec.ST].last.LINE = this.drivers[rec.ST].LINE + '';
                        this.drivers[rec.ST].update.LINE = this.compareData(rec.LINE, this.drivers[rec.ST].LINE);
                      }
                      if (rec.T !== this.drivers[rec.ST].T) {
                        this.drivers[rec.ST].last.T = this.drivers[rec.ST].T + '';
                        this.drivers[rec.ST].update.T = this.compareData(rec.T, this.drivers[rec.ST].T);
                      }
                      if (rec.G !== this.drivers[rec.ST].G) {
                        this.drivers[rec.ST].last.G = this.drivers[rec.ST].G + '';
                        this.drivers[rec.ST].update.G = this.compareData(rec.G, this.drivers[rec.ST].G);
                      }
                      if (rec.I !== this.drivers[rec.ST].I) {
                        this.drivers[rec.ST].last.I = this.drivers[rec.ST].I + '';
                        this.drivers[rec.ST].update.I = this.compareData(rec.I, this.drivers[rec.ST].I);
                      }
                      if (rec.FL !== this.drivers[rec.ST].FL) {
                        this.drivers[rec.ST].last.FL = this.drivers[rec.ST].FL + '';
                        this.drivers[rec.ST].update.FL = this.compareData(rec.FL, this.drivers[rec.ST].FL);
                      }
                      this.drivers[rec.ST].LINE = rec.LINE;
                      this.drivers[rec.ST].T = rec.T;
                      this.drivers[rec.ST].G = rec.G;
                      this.drivers[rec.ST].I = rec.I;
                      this.drivers[rec.ST].S1T = rec.S1T;
                      this.drivers[rec.ST].S2T = rec.S2T;
                      this.drivers[rec.ST].S3T = rec.S3T;
                      this.drivers[rec.ST].FL = rec.FL;
                      this.drivers[rec.ST].LAPS = rec.LAPS;
                    });
                    this.result = 'RESULT' in response ? response.RESULT : '';
                  } catch (e) {
                    //
                  }
                }
              }
              this.fetching = false;
            })
            .then(() => {
              this.fetching = false;
            });
        }
      }
    }
  },
  created () {
    this.fetchStream();
    this.liveInterval = setInterval(this.fetchStream, this.delayLive);
  },
  destroyed () {
    clearInterval(this.liveInterval);
  }
};
</script>

<style lang="scss">
.timing {
  width: 100%;
  border-collapse: collapse;
  tr {
    td, th {
      &.tl {
        text-align: left;
      }
      &.tr {
        text-align: right;
      }
      &.tc {
        text-align: center;
      }
    }
  }
  thead {
    background: rgba($color-bg-dark, 0.5);
    font-size: 0.8em;
    font-weight: 300;
    tr {
      td, th {
        white-space: nowrap;
        text-transform: uppercase;
        padding: 3px;
        padding-top: $gap / 2;
        font-weight: 100;
        &:first-child {
          padding-left: $gap;
        }
        &:last-child {
          padding-right: $gap;
        }
      }
    }
  }
  tbody {
    tr {
      transition: all .3s;
      &:nth-child(even) {
        background: rgba(255, 255, 255, 0.05);
      }
      td {
        white-space: nowrap;
        vertical-align: center;
        padding: 1px 3px;
        transition: color .3s;
        &:first-child {
          padding-left: $gap;
        }
        &:last-child {
          padding-right: $gap;
        }
        &.padding {
          padding: 1px 6px;
        }
        &.padding-right {
          padding-right: 12px;
        }
        &.padding-left {
          padding-right: 12px;
        }
        .timing__icon {
          fill: none;
          transition: all .3s $ease-out-back;
          transform: translate(0, 3px);
          &.timing__icon--up {
            transform: rotate(90deg) translate(3px, 0);
            fill: #0f0;
          }
          &.timing__icon--down {
            transform: rotate(-90deg) translate(-3px, 0);
            fill: #f00;
          }
        }
      }
      &:hover {
        background: rgba(#fff, 0.1);
      }
    }
  }
}
</style>
